import { mapProductTypeToProductCategory } from '@grandvisionhq/svc-tealium/utils';
import { mapProductToTealiumProperties } from './map-product-to-tealium-properties.js';

const mapProductsToTealiumViewProperties = (products, productType)=>{
    const mappedProducts = products.map((product)=>[
            product.masterVariant.sku,
            mapProductToTealiumProperties(product), 
        ]
    );
    let pageTitle = '';
    if (productType) {
        pageTitle = mapProductTypeToProductCategory(productType);
    }
    return {
        id: 'VirtualPage-View',
        Page_Type: 'Plp',
        Page_Section1: 'Catalog',
        Page_Section2: pageTitle,
        Products: Object.fromEntries(mappedProducts)
    };
};

export { mapProductsToTealiumViewProperties };
//# sourceMappingURL=map-products-to-tealium-view-properties.js.map
